import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import DatePicker from "../_components/datePicker";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import TableText from "./../../../component/atoms/text/table/tableText";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import SelectBox from "../../../component/organisms/selectBox";
import getRandomInt from "../../../util/getRandomInt";
import UserCountChart from "./_components/userCountChart";
import UserAnalysisChart from "./_components/userAnalysisChart";
import { errorHandler } from "../../../util/errorHandler";
import moment from "moment";
import AnalyticsApi from "../../../api/analytics.api";

// TODO:
// - 멤버십 회원 분석 탭 가려놓음 (추후에 추가 예정)

const StatisticsAnalysis = () => {
  // ---------- 탭 관련 ---------- //
  const [tab, setTab] = useState({
    user: true,
    analysis: false,
  });

  useEffect(() => {
    setDateType("day");
    setSelectedSort("신규");
    setSortListBoxOpen(false);
    setSelectedDate("");
  }, [tab]);

  // ---------- 날짜 선택 관련 ---------- //
  // 일간, 주간, 월간
  const [dateType, setDateType] = useState("day");

  // 선택된 날짜
  const [selectedDate, setSelectedDate] = useState("");

  // 기간 타입이 변경되면 선택된 날짜 초기화
  useEffect(() => {
    setSelectedDate("");
    setUserCountData([]);
  }, [dateType]);

  // ---------- 멤버십 회원 수 관련 ---------- //
  const [userCountData, setUserCountData] = useState([]);

  const getUserCountData = async (searchDate, startDate) => {
    const processedSearchDate = moment(searchDate).format("YYYY-MM-DD");

    let processedStartDate = "";
    if (startDate) {
      processedStartDate = moment(startDate).format("YYYY-MM-DD");
    }

    const data = {
      periodType: dateType,
      searchDate: processedSearchDate,
    };

    if (startDate) {
      data.startDate = processedStartDate;
    }

    try {
      const response = (await AnalyticsApi.getListMembership(data)).data.data
        .content;

      // response에서 daydate를 moment 돌려서 YYYY-MM-DD 형식으로 변환
      const processedResponse = response.map((item) => {
        return {
          ...item,
          date:
            dateType === "day"
              ? moment(item.daydate).format("YYYY-MM-DD")
              : dateType === "week"
              ? moment(item.weekdate).format("YYYY-MM-DD")
              : dateType === "month"
              ? moment(item.monthdate).format("YYYY-MM")
              : "",
          newcount: Number(item.newcount) || 0,
          cancelcount: Number(item.cancelcount) || 0,
          totalcount: Number(item.totalcount) || 0,
        };
      });

      setUserCountData(processedResponse);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (selectedDate && dateType === "day") {
      getUserCountData(selectedDate);
    } else if (selectedDate && dateType === "week") {
      // ex) "2024-12-16 (월) → 2024-12-22 (일)"
      const [startPart, endPart] = selectedDate
        .split("→")
        .map((part) => part.trim());

      const startDate = startPart.split(" ")[0]; // ex) "2024-12-16"
      const endDate = endPart.split(" ")[0]; // ex) "2024-12-22"

      getUserCountData(endDate, startDate);
    } else if (selectedDate && dateType === "month") {
      // selectedDate가 "2024-12" 이렇게 오면 해당하는 달의 1일을 추출
      const firstDayOfMonth = moment(selectedDate).startOf("month").format();

      getUserCountData(selectedDate, firstDayOfMonth);
    }
  }, [selectedDate]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 멤버십 회원 분석 관련 ---------- //
  // 필터링
  const [selectedSort, setSelectedSort] = useState("신규");

  const [sortListBoxOpen, setSortListBoxOpen] = useState(false);

  const sortList = [
    {
      title: "신규",
      value: "신규",
    },
    {
      title: "해지",
      value: "해지",
    },
    {
      title: "누적",
      value: "누적",
    },
  ];

  // 더미 데이터
  const dummyList = [
    { ageTitle: "0-12세" },
    { ageTitle: "13-18세" },
    { ageTitle: "19-24세" },
    { ageTitle: "25-29세" },
    { ageTitle: "30-34세" },
    { ageTitle: "35-39세" },
    { ageTitle: "40-44세" },
    { ageTitle: "45-49세" },
    { ageTitle: "50-54세" },
    { ageTitle: "55-59세" },
    { ageTitle: "60-세" },
  ];

  // 멤버십 회원 분석 - 연령별 더미 데이터
  const userAnalysisDummyData = [
    {
      age: "0-12세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "13-18세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "19-24세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "25-29세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "30-34세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "35-39세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "40-44세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "45-49세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "50-54세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "55-59세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
    {
      age: "60-세",
      male: getRandomInt(1000),
      female: getRandomInt(1000),
    },
  ];

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>멤버십 분석</TableTitle>
          <TabWrapper>
            <Tab
              isActive={tab.user}
              onClick={() => {
                setTab({
                  user: true,
                  analysis: false,
                });
              }}
            >
              <TabText isActive={tab.user}>멤버십 회원 수</TabText>
            </Tab>
            {/* <Tab
              isActive={tab.analysis}
              onClick={() => {
                setTab({
                  user: false,
                  analysis: true,
                });
              }}
            >
              <TabText isActive={tab.analysis}>멤버십 회원 분석</TabText>
            </Tab> */}
          </TabWrapper>

          <TabContentContainer>
            <TabContentHeader>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                }}
              >
                <DateTypeBtnWrapper>
                  <DateTypeBtn
                    isActive={dateType === "day"}
                    onClick={() => {
                      setDateType("day");
                    }}
                  >
                    일간
                  </DateTypeBtn>
                  <DateTypeBtn
                    isActive={dateType === "week"}
                    onClick={() => {
                      setDateType("week");
                    }}
                  >
                    주간
                  </DateTypeBtn>
                  <DateTypeBtn
                    isActive={dateType === "month"}
                    onClick={() => {
                      setDateType("month");
                    }}
                  >
                    월간
                  </DateTypeBtn>
                </DateTypeBtnWrapper>
                <DatePicker
                  dateType={dateType === "day" ? "date" : dateType}
                  isOnlyOneDate={true}
                  onClick={() => {}}
                  date={selectedDate}
                  dateHandler={setSelectedDate}
                />
              </div>
              {/* <ExcelBtn /> */}
            </TabContentHeader>

            {tab.user && (
              <>
                {/* 멤버십 회원 수 - 차트 데이터 */}
                <ChartContainer>
                  <ChartHeader>
                    <PretendardText
                      style={{
                        fontWeight: 700,
                        fontSize: "16px",
                        lineHeight: "28px",
                        letterSpacing: "-0.3%",
                        color: "#f3f3f3",
                      }}
                    >
                      차트 데이터
                    </PretendardText>
                  </ChartHeader>
                  <ChartGraphWrapper>
                    <div
                      style={{
                        width: "fit-content",
                        height: 23,
                        display: "flex",
                        alignItems: "center",
                        gap: 20,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#009bde",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          신규 멤버십 수
                        </PretendardText>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#cf6679",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          멤버십 해지수
                        </PretendardText>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#34f3ff",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          누적 멤버십 수
                        </PretendardText>
                      </div>
                    </div>
                  </ChartGraphWrapper>
                  <UserCountChart
                    dataList={userCountData}
                    dateType={dateType}
                  />

                  {/* 테이블 영역 */}
                  <table
                    style={{
                      width: "924px",
                      borderSpacing: 0,
                      borderCollapse: "collapse",
                      marginBottom: 40,
                    }}
                  >
                    <colgroup>
                      {/* 합계: 924px */}
                      {/* 날짜 */}
                      <col width="137px" />
                      {/* 신규 멤버십 수 */}
                      <col width="247px" />
                      {/* 멤버십 해지수 */}
                      <col width="224px" />
                      {/* 누적 멤버십 수 */}
                      <col width="316px" />
                    </colgroup>
                    <thead>
                      <tr
                        style={{
                          height: 41,
                          backgroundColor: "#313233",
                          borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              paddingLeft: 32,
                            }}
                          >
                            날짜
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            신규 멤버십 수
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            멤버십 해지수
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                              paddingRight: 92,
                            }}
                          >
                            멤버십 회원 수
                          </TableText>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {userCountData.map((item, index) => {
                        return (
                          <tr
                            key={index}
                            style={{
                              height: 40,
                              borderBottom:
                                "0.5px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            <td>
                              <TableText
                                style={{
                                  paddingLeft: 32,
                                }}
                              >
                                {dateType === "day" &&
                                  moment(item.daydate).format(
                                    "YYYY-MM-DD (ddd)"
                                  )}

                                {dateType === "week" && (
                                  <>
                                    {moment(item.weekdate).format(
                                      "YYYY-MM-DD (ddd)"
                                    )}
                                    {" → "}
                                    {moment(item.weekdate)
                                      .add(6, "days")
                                      .format("YYYY-MM-DD (ddd)")}
                                  </>
                                )}

                                {dateType === "month" && (
                                  <>
                                    {moment(item.monthdate).format("YYYY-MM")}{" "}
                                    월간
                                  </>
                                )}
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                }}
                              >
                                {formatNumberWithCommas(item.newcount)}
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                }}
                              >
                                {formatNumberWithCommas(item.cancelcount)}
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                  paddingRight: 92,
                                }}
                              >
                                {formatNumberWithCommas(item.totalcount)}
                              </TableText>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </ChartContainer>
              </>
            )}

            {/* ********** 멤버십 회원 분석 ********** */}
            {tab.analysis && (
              <>
                {/* 멤버십 회원 분석 - 차트 데이터 */}
                <ChartContainer>
                  <ChartHeader
                    style={{
                      height: 88,
                      justifyContent: "space-between",
                    }}
                  >
                    <ChartHeaderText>차트 데이터</ChartHeaderText>
                    <SelectBox
                      isMiddle={true}
                      selectedValue={selectedSort}
                      isOpen={sortListBoxOpen}
                      wrapperHandler={() => {
                        setSortListBoxOpen(!sortListBoxOpen);
                      }}
                      itemList={sortList}
                      selectedValueSetterFunc={(value) => {
                        setSelectedSort(value);
                        setSortListBoxOpen(false);
                      }}
                    />
                  </ChartHeader>
                  <ChartGraphWrapper>
                    <div
                      style={{
                        width: "fit-content",
                        height: 23,
                        display: "flex",
                        alignItems: "center",
                        gap: 20,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#009bde",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          남
                        </PretendardText>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#cf6679",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          여
                        </PretendardText>
                      </div>
                    </div>
                  </ChartGraphWrapper>

                  <UserAnalysisChart dataList={userAnalysisDummyData} />

                  {/* 테이블 영역 */}
                  <table
                    style={{
                      width: 924,
                      alignSelf: "center",
                      borderSpacing: 0,
                      borderCollapse: "collapse",
                      marginBottom: 50,
                    }}
                  >
                    <colgroup>
                      {/* 합계: 924px */}
                      {/* 연령 */}
                      <col width="330px" />
                      {/* 남 */}
                      <col width="318px" />
                      {/* 여 */}
                      <col width="276px" />
                    </colgroup>
                    <thead>
                      <tr
                        style={{
                          height: 41,
                          backgroundColor: "#313233",
                        }}
                      >
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              paddingLeft: 40,
                            }}
                          >
                            연령
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                            }}
                          >
                            남
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                            }}
                          >
                            여
                          </TableText>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        style={{
                          height: 39,
                          borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        <td>
                          <TableText
                            style={{
                              fontWeight: "700",
                              paddingLeft: 40,
                            }}
                          >
                            전체
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              fontWeight: "700",
                            }}
                          >
                            {formatNumberWithCommas(500)}{" "}
                            <span
                              style={{
                                color: "#009bde",
                              }}
                            >
                              (50%)
                            </span>
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              fontWeight: "700",
                              marginRight: 203,
                            }}
                          >
                            {formatNumberWithCommas(500)}{" "}
                            <span
                              style={{
                                color: "#cf6679",
                              }}
                            >
                              (50%)
                            </span>
                          </TableText>
                        </td>
                      </tr>
                      {dummyList.map((item, index) => {
                        return (
                          <>
                            <tr
                              key={index}
                              style={{
                                height: 39,
                                borderBottom:
                                  "0.5px solid rgba(255, 255, 255, 0.12)",
                              }}
                            >
                              <td>
                                <TableText
                                  style={{
                                    paddingLeft: 40,
                                  }}
                                >
                                  {item.ageTitle}
                                </TableText>
                              </td>
                              <td>
                                <TableText style={{}}>
                                  {formatNumberWithCommas(500)}{" "}
                                  <span
                                    style={{
                                      color: "#009bde",
                                    }}
                                  >
                                    (50%)
                                  </span>
                                </TableText>
                              </td>
                              <td>
                                <TableText
                                  style={{
                                    marginRight: 203,
                                  }}
                                >
                                  500
                                  <span
                                    style={{
                                      color: "#cf6679",
                                    }}
                                  >
                                    (50%)
                                  </span>
                                </TableText>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </ChartContainer>
              </>
            )}
          </TabContentContainer>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default StatisticsAnalysis;

const TabWrapper = styled.div.attrs((props) => {})`
  width: fit-content;
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 32px;
`;

const Tab = styled.div.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 19px 34.5px;
  border-bottom: ${(props) => (props.isActive ? "2px solid #27beff" : "none")};
  cursor: pointer;
`;

const TabText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.3%;
  color: ${(props) =>
    props.isActive ? "#27beff" : "rgba(181, 181, 181, 0.5)"};
`;

const TabContentContainer = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const TabContentHeader = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const DateTypeBtnWrapper = styled.div.attrs((props) => {})`
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DateTypeBtn = styled(PretendardText).attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 3px 10px;
  border-radius: 4px;
  border: ${(props) =>
    props.isActive
      ? "1px solid rgba(0, 155, 222, 1)"
      : "1px solid rgba(255, 255, 255, 0.12)"};
  background-color: #272829;
  font-weight: 500;
  font-size: 14px;
  line-height: 22.75px;
  text-align: center;
  color: ${(props) => (props.isActive ? "#009bde" : "#aaa")};
  cursor: pointer;
`;

const ChartContainer = styled.div.attrs((props) => {})`
  width: 1044px;
  height: fit-content;
  min-height: 439px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  border-radius: 10px;
  background: #272829;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
`;

const ChartHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 59px;
  display: flex;
  align-items: center;
  padding: 0px 30px;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.12);
`;

const ChartGraphWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  padding: 24px 30px;
`;

const ChartHeaderText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;
